import { render, staticRenderFns } from "./RecoveryPsChange.vue?vue&type=template&id=36dd7500&scoped=true"
import script from "./RecoveryPsChange.vue?vue&type=script&lang=js"
export * from "./RecoveryPsChange.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RecoveryPsChange.vue?vue&type=style&index=1&id=36dd7500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd7500",
  null
  
)

export default component.exports